import { MyAccountUrl } from "../directives/utilities/urls";
export default function completeDropCourses() {
    return {

        pendingDropScheduleList: [],
        totalRefund: 0,
        dropScheduleSummaryChargesList: [],
        totalSummaryChargesRefund: 0,
        isPendingCoursesAvailableToDrop: true,
        isPendingCoursesAvailableToDropMessage: '',
        dropCoursesReasons: [],
        showErrorMesage: '',

        isCompleteDropCourses: false,
        isCompleteDropCoursesMessage: '',
        isRevertDropCourses: [],
        isRevertDropCoursesMessage: '',

        isAssessDropCourses : false,
        isAssessDropCoursesMessage : '',

       isRefundProcess :false,
       isRefundProcessMessage :"",
        completeDropMessages: [],
        completeDropScheduleList: [],
        completeDropCreditLineItems: [],
        refundAmount: '',
        refundCompletedAmount: '',
        refundRemainingAmount: '',
        partialRefundCompleted: false,
        paymentMade:false,
        showLoader: false,
        isSubmitting: false,
        formatValue(value) {
            // Convert value to 0.00 format
            return parseFloat(value).toFixed(2);
        },
        checkDropCoursesAllowed() {
            fetch('/api/StudentAPI/CheckDropCoursesAllowed', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response != undefined && response.isSuccess) {
                        if (response.allowDropCourse) {
                            this.AssessDrop();
                        }
                        else {
                            window.location.href = MyAccountUrl;
                        }

                    } else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later."
                    }

                });

        },
        bindPendingDropSchedule() {
            this.isRevertDropCourses = [];
            fetch('/api/StudentAPI/GetPendingDropSchedule', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response != undefined && response.isSuccess) {
                        this.pendingDropScheduleList = response.scheduleList;
                        if (this.pendingDropScheduleList.length <= 0) {
                            this.isPendingCoursesAvailableToDrop = false;
                            window.location.href = document.getElementById('parentPageUrl').value;
                        }
                        else {
                            this.isPendingCoursesAvailableToDrop = true;
                            this.isPendingCoursesAvailableToDropMessage = "";
                            for (let j = 0; j < this.pendingDropScheduleList.length; j++) {
                                this.isRevertDropCourses[j] = "false";
                            }
                            this.totalRefund = response.totalRefund;
                            //this.AssessDrop();
                        }
                    } else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later. to get pending courses available to drop";
                    }

                });

        },
        bindDropScheduleSummary() {
           
           
            fetch('/api/StudentAPI/GetDropScheduleSummaryCharges', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response != undefined && response.isSuccess) {
                        this.dropScheduleSummaryChargesList = response.creditLineItemList;
                        this.totalSummaryChargesRefund = response.totalFee;
                       
                    } else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later. to get pending courses available to drop";
                    }

                });

        },
        AssessDrop() {
            this.showLoader = true;
           fetch('/api/StudentAPI/AssessDrop', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    
                })
            })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {
                    this.showLoader = false;
                    if (response.isSuccess) {
                        this.isAssessDropCourses = "true";
                        this.isAssessDropCoursesMessage = "";
                        this.bindPendingDropSchedule();
                    }
                    else {
                        this.isAssessDropCourses[index] = "false";
                        this.isAssessDropCoursesMessage = "Assessment error. Something went wrong to get assess drop data."
                    }
                });
        },
        RevertDropCourses(item, index) {
            fetch('/api/StudentAPI/RevertDropCourses', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    AcademicYear: item.academicYear,
                    AcademicTerm: item.academicTerm,
                    AcademicSession: item.academicSession,
                    SerialId: item.serialId,
                    Section: item.section,
                })
            })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response.isSuccess) {
                        this.isRevertDropCourses[index] = "true";
                        this.isRevertDropCoursesMessage = "Reverted successfully.";
                        this.bindPendingDropSchedule();
                    }
                    else {
                        this.isRevertDropCourses[index] = "false";
                        this.isRevertDropCoursesMessage = "Something went wrong."
                    }
                });
        },
        ProcessDropCourses() {
            this.isSubmitting = true;
            this.completeDropMessages = [];
                    fetch('/api/StudentAPI/ProcessDropCourses', {
                                method: 'POST',
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                   

                                })
                            })
                                .then(response => {
                                    if (response.ok) {
                                        return response.json()
                                    }
                                }).then(response => {
                                    

                                    if (response.isSuccess) {
                                        this.isCompleteDropCourses = true;
                                        this.isCompleteDropCoursesMessage = "";
                                        Array.prototype.push.apply(this.completeDropMessages, response.messages);
                                        Array.prototype.push.apply(this.completeDropScheduleList, response.scheduleList);
                                        Array.prototype.push.apply(this.completeDropCreditLineItems, response.creditLineItems);
                                        this.refundAmount = response.refundAmount;
                                        this.refundCompletedAmount = response.refundCompleted;
                                        this.refundRemainingAmount = response.refundRemaining;
                                        this.partialRefundCompleted = response.partialRefundCompleted;
                                        this.paymentMade = response.paymentMade;
                                        this.EndRefundProcess();
                                    }
                                    else {
                                        this.isCompleteDropCourses = false;
                                        this.isCompleteDropCoursesMessage = "Something went wrong to process drop courses.";
                                    }
                                    this.isSubmitting = false;
                                });
     
               
        },
        EndRefundProcess() {
           
                fetch('/api/StudentAPI/EndRefundProcess', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {
                    if (response != undefined && response.isSuccess) {
                        this.isRefundProcess = "true";
                        this.isRefundProcessMessage = "";
                    //    document.location.href = '/api/login/SignOut';
                    }
                    else {
                        this.isRefundProcess = "false";
                        this.isRefundProcessMessage = "Something went wrong to end refund process."
                    }
                });
        },
        
        init() {
            this.checkDropCoursesAllowed();
           
            this.bindDropScheduleSummary();

        }
    }
}